import { createApi } from '@reduxjs/toolkit/query/react'

import { FeatureType } from 'clickNgo/configs/feature'
import { axiosProcedureQuery, transformToProcedurePayload } from 'clickNgo/helpers/api'
import { ICallHistory } from 'clickNgo/models/calls'
import { I2029Form } from 'clickNgo/models/crud/forms'

import { mapCallHistoryFrom2029Form } from './mapping'

interface IPartnerContactCallHistoryParameters {
  partnerId: string
}

export const callHistoryApi = createApi({
  reducerPath: `${FeatureType.CngApi}/callHistory`,
  baseQuery: axiosProcedureQuery<I2029Form[]>(),
  endpoints(build) {
    return {
      partnerContactCallHistory: build.query<
        { items: ICallHistory[]; total: number },
        IPartnerContactCallHistoryParameters
      >({
        transformResponse(response) {
          if (response?.Data?.length) {
            return {
              items: response.Data.map(mapCallHistoryFrom2029Form),
              total: response.Total,
            }
          }

          return {
            items: [],
            total: 0,
          }
        },
        query(params) {
          return {
            url: `/webservice/197/sp/v4/spGetPartnerContactCallHistory/call`,
            method: 'POST',
            data: transformToProcedurePayload(params),
          }
        },
      }),
    }
  },
})

export const { usePartnerContactCallHistoryQuery } = callHistoryApi
